import { toRefs, computed } from 'vue';
import FlexSpacer from '../flex-spacer/component-lib.esm.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { getThemeColor, getTextColor } from '../../styles/theme/component-lib.esm3.js';

//
var script = {
  name: 'Alert',
  components: {
    FlexSpacer
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    variant: {
      type: String,
      default: null
    }
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      color,
      variant
    } = toRefs(props);
    const theme = useTheme();
    const themeColor = computed(() => {
      return getThemeColor(color.value, theme.value);
    });
    const textColor = computed(() => {
      return getTextColor(color.value, theme.value);
    });
    const styles = computed(() => {
      return {
        '--c-bg-color': themeColor.value,
        '--c-color': textColor.value
      };
    });
    const classes = computed(() => {
      return {
        [`v-alert--${variant.value}`]: variant.value !== null,
        [`v-alert--has-actions`]: slots.actions !== undefined
      };
    });
    return {
      styles,
      classes
    };
  }
};
export { script as default };